import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { selectNavigatedCustomerSpace } from '@core/core.selectors';
import { Store, select } from '@ngrx/store';
import { RootState } from '@root/app.state';
import { filter, map, first } from 'rxjs';

@Component({
  selector: 'app-cockpit-title',
  standalone: true,
  imports: [CommonModule],
  template: `
    <h1>{{ customerSpaceName }}</h1>
  `,
  styles: [
    `
      :host {
        display: block;
        h1 {
          padding-left: 5px; // on mobile left margin of container disappears and title sticks to the left
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CockpitTitleComponent {
  customerSpaceName: string;
  constructor(private store$: Store<RootState>) {
    this.store$
      .pipe(
        select(selectNavigatedCustomerSpace),
        filter((x) => !!x.data),
        map((x) => x.data),
        first(),
        takeUntilDestroyed(),
      )
      .subscribe((x) => (this.customerSpaceName = x.name));
  }
}
